angular.module("app").controller("PagesManageCategoriesController", [
    '$scope',
    '$uibModalInstance',
    '$timeout',
    '$uibModal',
    '$rootScope',
    'categoryPageId',
    'language',
    'pagesService',
    'errorHandler',
    'logger',
    'preloadedCategories',
    'pageStatuses',
    'toolsMap',
    'pagination',
    'categoryService',
    function ($scope, $modalInstance, $timeout, $modal, $rootScope, categoryPageId, language, pagesService, errorHandler, logger, preloadedCategories, pageStatuses, toolsMap, pagination, categoryService) {
        $scope.nameValidation = {pageName: ''};
        $scope.pageStatuses = pageStatuses;
        $scope.pageData = {
            name: "",
            title: ""
        };
        $scope.filterOptions = {
            status: pageStatuses[0]
        };

        $scope.pagination = pagination.init(function () {
                $scope.updateList();
        }, parseInt(preloadedCategories.total_count), 25, null, true);


        $scope.pages = preloadedCategories.items.map(extractCategory);
        var initialOrders = getValuesByKey($scope.pages, 'order');
        function initNames(preloadedPageData) {
            $scope.actualPageNames = angular.copy(preloadedPageData.names || preloadedPageData.pageNames) || null;
            $scope.usedNames = {};
            $scope.usedNamesByName = {};
            preloadedPageData.used && preloadedPageData.used.forEach(function (item) {
                $scope.usedNames[item] = true;
            });
            $scope.actualPageNames && ($scope.actualPageNames.forEach(function (value) {
               if ($scope.usedNames[value.id]) {
                   $scope.usedNamesByName[value.name] = true;
               }
            }));
            if($scope.actualPageNames) {
                var filteredPageNames = $scope.actualPageNames.filter(function (value) {
                    return !$scope.usedNames[value.id];
                });
                if (filteredPageNames.length > 0) {
                    $scope.pageData.name = filteredPageNames[0].name;
                }
            }
            $timeout(function () {
                $scope.$apply();
            })
        }
        initNames(preloadedCategories);


        /**
         * Cancel event listener
         */
        $scope.cancel = function cancel(){
            $modalInstance.dismiss('cancel');
        };

        /**
         * Save category
         */
        $scope.save = function save() {
            if (!$scope.create_category_form.$valid) {
                $scope.isSavePressed = true;
                return;
            }
            var requestData = {
                item: {
                    lang: language,
                    name: $scope.pageData.name,
                    page_id: categoryPageId,
                    status: 'published',
                    title: $scope.pageData.title,
                    type: 'category'
                }
            };
            pagesService.createPageItem(requestData).then(function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess('global.saved');
                        $scope.pageData.title = "";
                        $scope.pageData.name = "";
                        if (preloadedCategories.page.actualNamesPath) {
                            pagesService.getByExternalPath(preloadedCategories.page.actualNamesPath, {page_id: preloadedCategories.page.id}).then(function (namesResponse) {
                                initNames(namesResponse);
                                $("#nameSelect").trigger('chosen:updated');
                            });
                        }

                        $scope.create_category_form.pageTitle.$dirty = false;
                        $scope.create_category_form.pageTitle.$pristine = true;

                        $scope.updateList();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        /**
         * Name change listener
         */
        $scope.nameChangeListener = function () {
            $timeout(function () {
                if ($scope.pageData.name && $scope.pageData.name.length > 0) {
                    if (!/^[a-zA-Z0-9 \_\-]+$/.test($scope.pageData.name)) {
                        $scope.nameValidation.pageName = 'validationErrorMessages.namePatternMsg';
                        $scope.pageData.name = $scope.pageData.name.replace(/[^a-zA-Z0-9 \_\-]/g, '');
                    } else  {
                        $scope.nameValidation.pageName = '';
                        $scope.pageData.name = $scope.pageData.name.toLowerCase();
                        $scope.pageData.name = $scope.pageData.name.replace(/ |\_/g, '-');
                    }
                    $scope.$apply();
                }
            })

        };
        /**
         * Name paste listener
         */
        $scope.namePasteListener = function namePasteListener($event) {
            $event.preventDefault();
            var value = $event.originalEvent.clipboardData.getData('text/plain');
            if (value && value.length > 0) {
                if (!/^[a-zA-Z0-9 \_\-]+$/.test(value)) {
                    $scope.nameValidation.pageName = 'validationErrorMessages.namePatternMsg';
                    $timeout(function () {
                        $scope.nameValidation.pageName = '';
                    },1000)
                } else  {
                    $scope.nameValidation.pageName = '';
                    value = value.toLowerCase();
                    $scope.pageData.name =  value.replace(/ |\_/g, '-');
                }
                $timeout(function () {
                    $scope.$apply();
                })
            }
        };

        /**
         * Extract category from response item
         * @param item
         * @returns {{title: *, name: *, id: *}}
         */
        function extractCategory(item){
            return {
                title: item.title,
                name: item.name,
                id: item.id,
                order: item.order
            }
        }

        /**
         * Update categories list
         */
        $scope.updateList = function updateList() {
            pagesService.getPageItems({
                page_id: categoryPageId,
                limit: $scope.pagination.limit,
                status: $scope.filterOptions.status,
                current_page: $scope.pagination.page
            }).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.discardChanges();
                        $scope.pagination.totalItems = parseInt(response.total_count);
                        $scope.pages = response.items.map(extractCategory);
                        initialOrders = getValuesByKey($scope.pages, 'order');
                        initTools();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.listFilterObject = {
            action: function () {
                $scope.pagination.page = 1;
                $scope.updateList();
            }
        };

        $scope.ignoreColumns = {
            id: true,
            model: true,
            order: true
        };

        /**
         * Init tools when changing status
        */
        function initTools(){
            $scope.tools = {
                inactiveToggle: {
                    action: function (item) {
                        $scope.toolsAction(item, toolsMap[$scope.filterOptions.status].inactiveToggle.action, toolsMap[$scope.filterOptions.status].inactiveToggle.title)
                    },
                    class: function () {
                        return toolsMap[$scope.filterOptions.status].inactiveToggle.class;
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].inactiveToggle.title;
                    }
                },
                publishToggle: {
                    action: function (item) {
                        $scope.toolsAction(item, toolsMap[$scope.filterOptions.status].publishToggle.action, toolsMap[$scope.filterOptions.status].publishToggle.title  )
                    },
                    class: function () {
                        return toolsMap[$scope.filterOptions.status].publishToggle.class;
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].publishToggle.title;
                    }
                }
            };
        }


        $scope.toolsAction = function toolsAction(item, action, title){
            switch (action){
                case 'delete': {
                    var modalInstance = $modal.open({
                        templateUrl: "views/templates/modals/confirmDeleteAction.html",
                        controller: "ConfirmDeleteActionModalController"
                    });
                    modalInstance.result.then(function () {

                        pagesService.deleteItem(item, categoryPageId).then(
                            function (response) {
                                if (response.status == "ok") {
                                    logger.logSuccess("global.successfullyDeleted");
                                    $scope.updateList();
                                } else {
                                    errorHandler(response.message);
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                            }
                        );

                    });
                    break;
                }
                case 'toggleInactive': {
                    var modalInstance = $modal.open({
                        templateUrl: "views/templates/modals/confirmToggle" + title + "Action.html",
                        controller: "ConfirmDeleteActionModalController"
                    });
                    modalInstance.result.then(function () {
                        pagesService.toggleItemInactive(item, categoryPageId, title !== 'Publish').then(
                            function (response) {
                                if (response.status === "ok") {
                                    logger.logSuccess("global.updated");
                                    $scope.updateList();
                                } else {
                                    errorHandler(response.message);
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                            }
                        )

                    });
                    break;
                }
            }
        };

        initTools();

        /**
         * Edit table
         */
        $scope.editPage = function editPage() {
            if ($scope.tableIsInEditMode){
                return;
            }
            $scope.tableIsInEditMode = true;
            var pagesLength = $scope.pages.length;
            for(var i = 0; i < pagesLength; ++i){
                var row = $scope.pages[i];
                $scope.pages[i].model = {};
                $scope.pages[i].model.title = row.title;
                $scope.pages[i].model.name = row.name;
                $scope.usedNamesByName && ($scope.usedNamesByName[row.name] = false);
            }
            $scope.updateRow = {
                'title':  {type:"text", requiredMessage: 'titleRequired' },
            };
            if ($scope.actualPageNames) {
                $scope.updateRow['name'] = {type: "slug", used: $scope.usedNamesByName };
                $scope.updateRow['name'].options = $scope.actualPageNames.map(function (value) { return value.name });
            } else {
                $scope.updateRow['name'] = {type: 'notRequiredText'};
            }
            $rootScope.broadcast('changeToEditMode', true);
        }

        /**
         * Discard table changes
         */
        $scope.discardChanges = function discardChanges() {
            if ($scope.tableIsInEditMode) {
                $scope.tableIsInEditMode = false;
                $rootScope.broadcast('changeToEditMode', false);
            }
        };

        /**
         * Check is table changed in editable mode
         */
        $scope.checkForChanges = function checkForChanges() {
            if ($scope.tableIsInEditMode){
                var tableLength = $scope.pages.length;
                for(var i = 0; i < tableLength; ++i) {
                    var row = $scope.pages[i];
                   if (row.title !== row.model.title) {
                       return true;
                   }
                   if (row.name !== row.model.name) {
                       return true;
                   }
                }
                return false;
            }
            return true;
        };

        /**
         * Check is table data valid
         * @returns {boolean}
         */
        function checkIsValid(){
            if($scope.tableIsInEditMode) {
                var pagesLength = $scope.pages.length;
                var counts = {};
                for(var i = 0; i < pagesLength; ++i){
                    if (!$scope.pages[i].model.title) {
                        return false;
                    }
                    if ($scope.pages[i].model.name && counts[$scope.pages[i].model.name]) {
                        logger.logError("global.nameMustBeUnique");
                        return false;
                    }
                    counts[$scope.pages[i].model.name] = 1;
                }
            }
            return true;
        }

        /**
         * Create edit table request data
         * @returns {{items: Array}}
         */
        function createRequestData(){
            var items = [];
            var pagesLength = $scope.pages.length;
            for (var i = 0; i < pagesLength; ++i) {
                var row = $scope.pages[i];
                if(row.title !== row.model.title || row.name !== row.model.name) {
                    var item = {
                        id: row.id
                    };
                    if (row.title !== row.model.title) {
                        item.title = row.model.title;
                    }
                    if (row.name !== row.model.name) {
                        item.name = row.model.name;
                    }
                    items.push(item);
                }
            }
            return {
                items: items
            };
        }

        /**
         * Save table edited titles
         */
        $scope.savePage = function savePage() {
            if ($scope.tableIsInEditMode) {
                if (!checkIsValid()) {
                    return;
                }else if (!$scope.checkForChanges()) {
                    logger.logError("global.no_changes");
                    return;
                }
                categoryService.changeItems(createRequestData()).then( function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess("global.updated");
                            if (preloadedCategories.page.actualNamesPath) {
                                pagesService.getByExternalPath(preloadedCategories.page.actualNamesPath, {page_id: preloadedCategories.page.id}).then(function (namesResponse) {
                                    initNames(namesResponse);
                                    $("#nameSelect").trigger('chosen:updated');
                                });
                            }
                            $scope.updateList();
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                );
            }
        };

        $scope.allowUpdateContainer = {};

        /**
         * Ordering change function
         * @param options
         */
        $scope.allowUpdateContainer.allowUpdate = function (options) {
            if (options && options.autoUpdate) {
                reorder();
            }
        };
        function reorder () {
            if (typeof $scope.pages === "object" && $scope.pages.length) {
                reorderByService({
                    ids: getValuesByKey($scope.pages, 'id'),
                    orders: initialOrders,
                    parentId: categoryPageId
                }, pagesService);
            }
        }

        function reorderByService (orderData, service) {
            service.changeOrder({
                orderData: orderData
            }).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("global.updated")
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }
    }



]);